module.exports = __webpack_public_path__ + "img/background.b087ca4d.jpg";